import { useTranslations } from '@vocab/react';
import { Step as StepComp, Stepper } from 'braid-design-system';

import { useConfig } from 'src/context/config';

import translations from './.vocab';

export enum Step {
  Documents = 'documents',
  RoleRequirements = 'role-requirements',
  Profile = 'profile',
  Review = 'review',
}

interface Props {
  /** The furthest progress index of the application, starts with 0 */
  progress: number;
  /** The current step index of the application, starts with 0 */
  current: number;
  shouldIncludeRoleRequirements?: boolean;
}

export function Progress({
  progress,
  current,
  shouldIncludeRoleRequirements = false,
}: Props) {
  const { t } = useTranslations(translations);
  const { config } = useConfig();

  return (
    <Stepper
      label={t('Progress bar')}
      align="left"
      progress={progress + 1}
      activeStep={current + 1}
    >
      <>
        <StepComp key={Step.Documents}>{t('Choose documents')}</StepComp>
        {shouldIncludeRoleRequirements && (
          <StepComp key={Step.RoleRequirements}>
            {t('Answer employer questions')}
          </StepComp>
        )}
        <StepComp key={Step.Profile}>
          {t('Update SEEK Profile', { brand: config.BRAND })}
        </StepComp>
        <StepComp key={Step.Review}>{t('Review and submit')}</StepComp>
      </>
    </Stepper>
  );
}
